<span class="label">
    {{displayName}}
</span>
<mat-icon class="icon"
          color="accent"
          [class.selected]="isSelected"
          [class.descending]="isDescending">
    sort
</mat-icon>
